import React, { useState, Component } from 'react';
import { Briefcase, FileText, Mail, Send, User, Phone, MessageSquare } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
const targetEmails = ['asistenciagestionhumana@grector.com', 'gestionhumana@grector.com', 'gerentegestionhumana@grector.com', 'rrhh@grector.com'];
const positions = ['Operador de Estación', 'Técnico', 'Administrativo', 'Chofer', 'Otro'];
const inputStyle = {
  backgroundColor: 'var(--input-bg)',
  borderColor: 'var(--border-color)',
  color: 'var(--text-primary)'
};
const inputClass = 'w-full px-4 py-3 border focus:outline-none focus:border-[#FCEE02] focus:ring-2 focus:ring-[#FCEE02]/20 transition-all rounded-lg';
export function CareersSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    posicion: '',
    mensaje: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      id,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Solicitud de Empleo - ${formData.posicion || 'General'} - ${formData.nombre}`);
    const body = encodeURIComponent(`Nombre: ${formData.nombre}
Email: ${formData.email}
Teléfono: ${formData.telefono}
Posición Deseada: ${formData.posicion}

Mensaje/Carta de Presentación:
${formData.mensaje}

[POR FAVOR ADJUNTE SU CV/HOJA DE VIDA A ESTE CORREO ANTES DE ENVIAR]`);
    const mailtoLink = `mailto:${targetEmails.join(',')}?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  };
  return <section className="py-16 sm:py-24 relative overflow-hidden transition-colors duration-300" style={{
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-47">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'linear-gradient(#FB900D 1px, transparent 1px), linear-gradient(90deg, #FB900D 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-48" />

      <div className="container mx-auto px-4 sm:px-6 md:px-12 relative z-10" data-id="element-49">
        <AnimateOnScroll className="mb-12 sm:mb-16 max-w-3xl" data-id="element-50">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter mb-6 transition-colors duration-300" style={{
          color: 'var(--text-primary)'
        }} data-id="element-51">
            Trabaja con{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FB900D] to-[#FCEE02]" data-id="element-52">
              Nosotros
            </span>
          </h2>
          <p className="text-lg sm:text-xl border-l-4 border-[#FB900D] pl-4 sm:pl-6 transition-colors duration-300" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-53">
            Únete a nuestro equipo. Buscamos talento comprometido con la
            excelencia y el servicio. Envíanos tu CV y forma parte de la familia
            Junquito Gas.
          </p>
        </AnimateOnScroll>

        <div className="max-w-3xl mx-auto" data-id="element-54">
          {/* Form */}
          <AnimateOnScroll direction="up" data-id="element-55">
            <div className="p-6 sm:p-8 border rounded-xl shadow-xl relative overflow-hidden" style={{
            backgroundColor: 'var(--card-bg)',
            borderColor: 'var(--border-color)'
          }} data-id="element-56">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#FB900D] to-[#FCEE02]" data-id="element-57" />

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-58">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-59">
                  <div className="space-y-2" data-id="element-60">
                    <label htmlFor="nombre" className="text-sm font-bold uppercase tracking-wider flex items-center gap-2" style={{
                    color: 'var(--text-primary)'
                  }} data-id="element-61">
                      <User className="w-4 h-4 text-[#FB900D]" data-id="element-62" />
                      Nombre Completo *
                    </label>
                    <input type="text" id="nombre" required value={formData.nombre} onChange={handleChange} className={inputClass} style={inputStyle} placeholder="Ej. Juan Pérez" data-id="element-63" />
                  </div>
                  <div className="space-y-2" data-id="element-64">
                    <label htmlFor="email" className="text-sm font-bold uppercase tracking-wider flex items-center gap-2" style={{
                    color: 'var(--text-primary)'
                  }} data-id="element-65">
                      <Mail className="w-4 h-4 text-[#FB900D]" data-id="element-66" />
                      Correo Electrónico *
                    </label>
                    <input type="email" id="email" required value={formData.email} onChange={handleChange} className={inputClass} style={inputStyle} placeholder="ejemplo@correo.com" data-id="element-67" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-68">
                  <div className="space-y-2" data-id="element-69">
                    <label htmlFor="telefono" className="text-sm font-bold uppercase tracking-wider flex items-center gap-2" style={{
                    color: 'var(--text-primary)'
                  }} data-id="element-70">
                      <Phone className="w-4 h-4 text-[#FB900D]" data-id="element-71" />
                      Teléfono *
                    </label>
                    <input type="tel" id="telefono" required value={formData.telefono} onChange={handleChange} className={inputClass} style={inputStyle} placeholder="(000) 000-0000" data-id="element-72" />
                  </div>
                  <div className="space-y-2" data-id="element-73">
                    <label htmlFor="posicion" className="text-sm font-bold uppercase tracking-wider flex items-center gap-2" style={{
                    color: 'var(--text-primary)'
                  }} data-id="element-74">
                      <Briefcase className="w-4 h-4 text-[#FB900D]" data-id="element-75" />
                      Posición Deseada *
                    </label>
                    <select id="posicion" required value={formData.posicion} onChange={handleChange} className={inputClass} style={inputStyle} data-id="element-76">
                      <option value="" disabled data-id="element-77">
                        Seleccione una posición
                      </option>
                      {positions.map(pos => <option key={pos} value={pos} data-id="element-78">
                          {pos}
                        </option>)}
                    </select>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-79">
                  <label htmlFor="mensaje" className="text-sm font-bold uppercase tracking-wider flex items-center gap-2" style={{
                  color: 'var(--text-primary)'
                }} data-id="element-80">
                    <MessageSquare className="w-4 h-4 text-[#FB900D]" data-id="element-81" />
                    Mensaje / Carta de Presentación
                  </label>
                  <textarea id="mensaje" rows={4} value={formData.mensaje} onChange={handleChange} className={`${inputClass} resize-none`} style={inputStyle} placeholder="Cuéntanos sobre tu experiencia y por qué quieres unirte a nuestro equipo..." data-id="element-82" />
                </div>

                <div className="pt-4" data-id="element-83">
                  <button type="submit" className="w-full sm:w-auto px-8 py-4 bg-[#FB900D] text-white font-black uppercase tracking-wider hover:bg-[#EC2424] transition-colors duration-200 border-2 border-[#FB900D] hover:border-[#EC2424] rounded-xl flex items-center justify-center gap-3 group" data-id="element-84">
                    <FileText className="w-5 h-5" data-id="element-85" />
                    Preparar Correo con CV
                    <Send className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" data-id="element-86" />
                  </button>
                  <p className="mt-4 text-sm flex items-start gap-2" style={{
                  color: 'var(--text-muted)'
                }} data-id="element-87">
                    <span className="text-[#FB900D] font-bold" data-id="element-88">Nota:</span> Al
                    hacer clic en el botón, se abrirá su cliente de correo
                    predeterminado.
                    <strong style={{
                    color: 'var(--text-primary)'
                  }} data-id="element-89">
                      {' '}
                      Por favor, no olvide adjuntar su CV/hoja de vida al correo
                      antes de enviarlo.
                    </strong>
                  </p>
                </div>
              </form>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}